export const AGENT_RESUME_KEY = 'husl_agent_resume';

export interface AgentResumePayload {
  sessionId: string;
  message: string;
  openChat: boolean;
}

export interface AgentHandoffState {
  sessionId: string;
  token?: string;
  mobile?: string;
  amount?: string;
  currency?: string;
}

export function setAgentResume(payload: AgentResumePayload): void {
  sessionStorage.setItem(AGENT_RESUME_KEY, JSON.stringify(payload));
}

export function consumeAgentResume(): AgentResumePayload | null {
  const raw = sessionStorage.getItem(AGENT_RESUME_KEY);
  if (!raw) {
    return null;
  }
  sessionStorage.removeItem(AGENT_RESUME_KEY);
  try {
    return JSON.parse(raw) as AgentResumePayload;
  } catch {
    return null;
  }
}

export function persistAgentSessionId(sessionId: string): void {
  sessionStorage.setItem('husl_agent_session_id', sessionId);
}

export function getPersistedAgentSessionId(): string | null {
  return sessionStorage.getItem('husl_agent_session_id');
}

export function persistAgentStylistDisplayName(name: string): void {
  sessionStorage.setItem('husl_agent_stylist_display_name', name);
}

export function getPersistedAgentStylistDisplayName(): string | null {
  return sessionStorage.getItem('husl_agent_stylist_display_name');
}

export function persistAgentStylistCode(code: string): void {
  sessionStorage.setItem('husl_agent_stylist_code', code);
}

export function getPersistedAgentStylistCode(): string | null {
  return sessionStorage.getItem('husl_agent_stylist_code');
}

export function getAgentHandoffFromLocation(
  search: string,
  state?: AgentHandoffState,
): AgentHandoffState {
  const fromState = state || {};
  if (fromState.sessionId) {
    return fromState;
  }
  const params = new URLSearchParams(search);
  const sessionId = params.get('session_id');
  if (!sessionId) {
    return fromState;
  }
  return {
    sessionId,
    token: params.get('token') || undefined,
    mobile: params.get('mobile') || undefined,
    amount: params.get('amount') || undefined,
    currency: params.get('currency') || undefined,
  };
}

export function parseEmbedResumeFromUrl(): AgentResumePayload | null {
  const params = new URLSearchParams(window.location.search);
  const sessionId = params.get('husl_agent_session');
  if (!sessionId) {
    return null;
  }
  return {
    sessionId,
    message: params.get('husl_agent_message') || 'Continue booking.',
    openChat: true,
  };
}

export function buildEmbedReturnUrl(
  returnUrl: string,
  sessionId: string,
  message: string,
): string {
  const url = new URL(returnUrl);
  url.searchParams.set('husl_agent_session', sessionId);
  url.searchParams.set('husl_agent_message', message);
  return url.toString();
}
